import type { DocumentResponse, CreateDocumentRequest, MarkUploadedRequest } from '@/types/upload';
import { apiRequest } from './apiClient';

export const expertProfileUploadApi = {
  async createDocument(data: CreateDocumentRequest): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(
      '/admin/experts/upload/create',
      {
        method: 'POST',
        body: data,
      }
    );
    return result.data;
  },

  async markAsUploaded(data: MarkUploadedRequest): Promise<void> {
    await apiRequest<void>('/admin/experts/upload/mark-uploaded', {
      method: 'POST',
      body: data,
    });
  },

  async getDocument(documentId: number): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(
      `/admin/experts/upload/${documentId}`
    );
    return result.data;
  },
};
